define('core/webidl-clipboard',["exports", "deps/text!core/images/clipboard.svg", "deps/clipboard"], function (exports, _clipboard, _clipboard3) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.name = undefined;
  exports.run = run;

  var _clipboard2 = _interopRequireDefault(_clipboard);

  var _clipboard4 = _interopRequireDefault(_clipboard3);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Module core/webidl-clipboard
   *
   * This module adds a button to each IDL pre making it possible to copy
   * well-formatted IDL to the clipboard.
   *
   */
  const name = exports.name = "core/webidl-clipboard";

  // This button serves a prototype that we clone as needed.
  const copyButton = document.createElement("button");
  copyButton.innerHTML = _clipboard2.default;
  copyButton.title = "Copy IDL to clipboard";
  copyButton.classList.add("respec-button-copy-paste", "removeOnSave");

  const clipboardOps = {
    text: trigger => {
      return document.querySelector(trigger.dataset.clipboardTarget).textContent.replace(/ +/gm, " ").replace(/^ /gm, "  ").replace(/^};\n/gm, "};\n").trim();
    }
  };

  async function run(conf, doc, cb) {
    Array.from(doc.querySelectorAll("pre.idl")).map(elem => {
      const button = copyButton.cloneNode(true);
      const definition = elem.querySelector(`span[id^="idl-def-"], span[id^="dom-"]`);
      let target = "#";
      if (definition === null && elem.id === "") {
        if (elem.parentElement.id === "idl-index") {
          target += "actual-idl-index";
        } else {
          elem.id = `idl-${String(Math.random()).substr(2)}`;
          target += elem.id;
        }
      } else {
        target += elem.id || definition.id;
      }
      return { button, elem, target };
    }).forEach(({ elem, button, target }) => {
      const wrapper = doc.createElement("div");
      button.dataset.clipboardTarget = target;
      elem.parentElement.replaceChild(wrapper, elem);
      wrapper.appendChild(button);
      wrapper.appendChild(elem);
    });
    const clipboard = new _clipboard4.default(".respec-button-copy-paste", clipboardOps);
    clipboard.on("success", e => e.clearSelection());
    cb();
  }
});
//# sourceMappingURL=webidl-clipboard.js.map;
